// import React, { useEffect, useState } from "react";
// import "./EventOverview.scss";
// import { TitleBar } from "../../Global/TitleBar/TitleBar";
// import { TopBar } from "../TopBar/TopBar";
// import {
//   Description,
//   DescriptionContent,
//   EventHeading,
//   SubHeading,
// } from "../../Global/GlobalText";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import ProgressBar from 'react-bootstrap/ProgressBar';
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import { EXCHNAGE_URL } from "../../../Url/Url";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import { Spinner } from "react-bootstrap";
// import { useLoading } from "../../LoadingContext";


// ChartJS.register(ArcElement, Tooltip, Legend);

// export const EventOverview = () => {

//   const location = useLocation()
//   const { eventUrl, eventName } = location.state || {};
//   const { setLoading } = useLoading(); // Use global loader
//   const [progressData, setProgressData] = useState([]);
//   const eventIdGet = useSelector((state) => state?.users?.id || "");
//   const eventId = String(eventIdGet);


//   const handleProgress = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `${EXCHNAGE_URL}/juryProgress?eventId=${eventId}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       if (response.status === 200) {
//         const data = response.data.data || [];
//         setProgressData(data);
//       } else {
//         toast.error("Failed to fetch the registration form.");
//         setProgressData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setProgressData([]);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     handleProgress()
//   }, [eventId])

//   const totalSubmissions = progressData?.reduce(
//     (acc, category) => acc + (category.totalSubmissionsInAward || 0),
//     0
//   );
//   const totalJudged = progressData?.reduce(
//     (acc, category) => acc + (category.totalAwardIdsInJuryScore || 0),
//     0
//   );


//   return (
//     <div>
//       <div className="event_overview_div">
//         <TitleBar title="Event Overview" />

//         <div className="event_overview_white_bg">
//           <TopBar titleheading={eventName} eventUrl={eventUrl} />

//           <div className="event_overview_progress_summary">
//             <div className="event_overview_progress">
//             <SubHeading>Jury Progress</SubHeading>

//          {setLoading ? (
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       minHeight: "250px",
//     }}
//   >
//     <Spinner animation="border" variant="primary" />
//   </div>
// ) : progressData.length > 0 ? (
//   progressData.map((category, index) => {
//     const progress = category.totalSubmissionsInAward
//       ? Math.round(
//           (category.totalAwardIdsInJuryScore /
//             category.totalSubmissionsInAward) *
//             100
//         )
//       : 0;

//     return (
//       <div className="event_overview_sub" key={index}>
//         <Description>
//           Category:{" "}
//           <span style={{ color: "#333333" }}>
//             {category.category_name}
//           </span>
//         </Description>

//         <EventHeading style={{ fontWeight: "400" }}>
//           Progress (Click on the progress bar to see the progress by Judge):
//         </EventHeading>

//         <div className="prgogess_bar">
//           <DescriptionContent>
//             {`${category.totalAwardIdsInJuryScore} of ${category.totalSubmissionsInAward}`}
//           </DescriptionContent>

//           <ProgressBar
//             variant="success"
//             now={progress}
//             label={`${progress}%`}
//           />
//         </div>
//       </div>
//     );
//   })
// ) : (
//   <p style={{ textAlign: "center", color: "#888" }}>
//     No progress data available.
//   </p>
// )}
//             </div>

//             <div className="event_overview_summary">
//             <SubHeading>Submission Summary</SubHeading>
//             <div className="event_overview_chart">
//               {progressData.length > 0 ? (
//                 <>
//                   <div
//                     style={{
//                       width: "200px",
//                       height: "200px",
//                       margin: "auto",
//                     }}
//                   >
//                     <Doughnut
//                       data={{
//                         labels: ["Total Submissions", "Submissions Judged"],
//                         datasets: [
//                           {
//                             data: [totalSubmissions, totalJudged],
//                             backgroundColor: ["#FBBD1C", "#198754"],
//                           },
//                         ],
//                       }}
//                       options={{
//                         maintainAspectRatio: false,
//                         responsive: true,
//                       }}
//                     />
//                   </div>

//                   <div
//                     style={{
//                       marginTop: "20px",
//                       display: "flex",
//                       gap: "10px",
//                       flexDirection: "column",
//                     }}
//                   >
//                     <div className="event-overview_chartstatus">
//                       <div className="event_overview_status_heading">
//                         <span
//                           style={{
//                             width: "12px",
//                             height: "12px",
//                             backgroundColor: "#FBBD1C",
//                             marginRight: "8px",
//                             borderRadius: "3px",
//                           }}
//                         ></span>
//                         <DescriptionContent>Total Submissions</DescriptionContent>
//                       </div>
//                       <DescriptionContent style={{ marginLeft: "auto" }}>
//                         {totalSubmissions}
//                       </DescriptionContent>
//                     </div>

//                     <div className="event-overview_chartstatus">
//                       <div className="event_overview_status_heading">
//                         <span
//                           style={{
//                             width: "12px",
//                             height: "12px",
//                             backgroundColor: "#198754",
//                             marginRight: "8px",
//                             borderRadius: "3px",
//                           }}
//                         ></span>
//                         <DescriptionContent>Submissions Judged</DescriptionContent>
//                       </div>
//                       <DescriptionContent style={{ marginLeft: "auto" }}>
//                         {totalJudged}
//                       </DescriptionContent>
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 <p style={{ textAlign: "center", color: "#888" }}>
//                   No submission data available.
//                 </p>
//               )}
//             </div>
//           </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState } from "react";
import "./EventOverview.scss";
import { TitleBar } from "../../Global/TitleBar/TitleBar";
import { TopBar } from "../TopBar/TopBar";
import {
  Description,
  DescriptionContent,
  EventHeading,
  SubHeading,
} from "../../Global/GlobalText";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useLocation } from "react-router-dom";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../Url/Url";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { useLoading } from "../../LoadingContext";


ChartJS.register(ArcElement, Tooltip, Legend);

export const EventOverview = () => {

  const location = useLocation()
  const { eventUrl, eventName } = location.state || {};
  const { loading, setLoading } = useLoading(); // ✅ FIX: Added loading state
  const [progressData, setProgressData] = useState([]);
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const eventId = String(eventIdGet);


  const handleProgress = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/juryProgress?eventId=${eventId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        const data = response.data.data || []; 
        setProgressData(data);
      } else {
        toast.error("Failed to fetch the registration form.");
        setProgressData([]); 
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setProgressData([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleProgress()
  }, [eventId])

  const totalSubmissions = progressData?.reduce(
    (acc, category) => acc + (category.totalSubmissionsInAward || 0),
    0
  );
  const totalJudged = progressData?.reduce(
    (acc, category) => acc + (category.totalAwardIdsInJuryScore || 0),
    0
  );


  return (
    <div>
      <div className="event_overview_div">
        <TitleBar title="Event Overview" />

        <div className="event_overview_white_bg">
          <TopBar titleheading={eventName} eventUrl={eventUrl} />

          <div className="event_overview_progress_summary">
            <div className="event_overview_progress">
            <SubHeading>Jury Progress</SubHeading>

         {loading ? ( // ✅ FIX: Changed setLoading to loading
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "250px",
    }}
  >
    <Spinner animation="border" variant="primary" />
  </div>
) : progressData.length > 0 ? (
  progressData.map((category, index) => {
    const progress = category.totalSubmissionsInAward
      ? Math.round(
          (category.totalAwardIdsInJuryScore /
            category.totalSubmissionsInAward) *
            100
        )
      : 0;

    return (
      <div className="event_overview_sub" key={index}>
        <Description>
          Category:{" "}
          <span style={{ color: "#333333" }}>
            {category.category_name}
          </span>
        </Description>

        <EventHeading style={{ fontWeight: "400" }}>
          Progress (Click on the progress bar to see the progress by Judge):
        </EventHeading>

        <div className="prgogess_bar">
          <DescriptionContent>
            {`${category.totalAwardIdsInJuryScore} of ${category.totalSubmissionsInAward}`}
          </DescriptionContent>

          <ProgressBar
            variant="success"
            now={progress}
            label={`${progress}%`}
          />
        </div>
      </div>
    );
  })
) : (
  <p style={{ textAlign: "center", color: "#888" }}>
    No progress data available.
  </p>
)}
            </div>

            <div className="event_overview_summary">
            <SubHeading>Submission Summary</SubHeading>
            <div className="event_overview_chart">
              {progressData.length > 0 ? (
                <>
                  <div
                    style={{
                      width: "200px",
                      height: "200px",
                      margin: "auto",
                    }}
                  >
                    <Doughnut
                      data={{
                        labels: ["Total Submissions", "Submissions Judged"],
                        datasets: [
                          {
                            data: [totalSubmissions, totalJudged],
                            backgroundColor: ["#FBBD1C", "#198754"], 
                          },
                        ],
                      }}
                      options={{
                        maintainAspectRatio: false,
                        responsive: true,
                      }}
                    />
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                    }}
                  >
                    <div className="event-overview_chartstatus">
                      <div className="event_overview_status_heading">
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#FBBD1C",
                            marginRight: "8px",
                            borderRadius: "3px",
                          }}
                        ></span>
                        <DescriptionContent>Total Submissions</DescriptionContent>
                      </div>
                      <DescriptionContent style={{ marginLeft: "auto" }}>
                        {totalSubmissions}
                      </DescriptionContent>
                    </div>

                    <div className="event-overview_chartstatus">
                      <div className="event_overview_status_heading">
                        <span
                          style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: "#198754",
                            marginRight: "8px",
                            borderRadius: "3px",
                          }}
                        ></span>
                        <DescriptionContent>Submissions Judged</DescriptionContent>
                      </div>
                      <DescriptionContent style={{ marginLeft: "auto" }}>
                        {totalJudged}
                      </DescriptionContent>
                    </div>
                  </div>
                </>
              ) : (
                <p style={{ textAlign: "center", color: "#888" }}>
                  No submission data available.
                </p>
              )}
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};